import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import UploadFacebookAdCreative from '../../../../forms/Facebook/UploadFacebookAdCreative'
import UploadGoogleAdCreative from '../../../../forms/Google/UploadGoogleAdCreative'
import UploadTikTokCreative from '../../../../forms/Tiktok/UploadTikTokAdCreative'
import UploadDV360AdCreative from '../../../../forms/DV360/UploadDV360AdCreative'
import CombinedFacebookTiktokCreate from '../../../../forms/Multiplatform/CombinedFacebookTiktokCreate'

import useAvailablePlatforms from '../useAvailablePlatforms'

import { isNewStylesThemeEnabledSelector } from '../../../../modules/selectors/app'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../../constants/selectLists/platformList'
import useSummaryPagesStyles from '../../../../styles/common/summaryPages'

const UploadAdForms = () => {
  const isNewStylesThemeEnabled = useSelector(isNewStylesThemeEnabledSelector)
  const summaryPagesClasses = useSummaryPagesStyles()

  const { t } = useTranslation()

  const {
    [FACEBOOK_PLATFORM]: showFacebookForm,
    [GOOGLE_PLATFORM]: showGoogleForm,
    [DV_360_PLATFORM]: showDV360Form,
    [TIKTOK_PLATFORM]: showTikTokForm
  } = useAvailablePlatforms()

  if (!showFacebookForm && !showGoogleForm && !showDV360Form && !showTikTokForm) {
    return null
  }

  return (
    <>
      <h2 className={summaryPagesClasses.welcomeMessage}>{t('Which type of ad creative would you like to upload?')}</h2>
      <div className={summaryPagesClasses.welcomeButtonsWrapper}>
        {/*for now we show this form only for new theme to avoid showing not ready form for old theme users in production*/}
        {(showFacebookForm || showTikTokForm) && isNewStylesThemeEnabled && <CombinedFacebookTiktokCreate />}
        {showFacebookForm && <UploadFacebookAdCreative />}
        {showGoogleForm && <UploadGoogleAdCreative />}
        {showDV360Form && <UploadDV360AdCreative />}
        {showTikTokForm && <UploadTikTokCreative />}
      </div>
    </>
  )
}

export default UploadAdForms
